module.exports = __webpack_public_path__ + "img/colored-paper-5.b01d9539.png";